import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'antd';

import SearchInput from '../../../../../Constants/SearchInput';
import {
  DeleteArticleAction,
  GetSearchArticleAction,
  UpdateArticleAction,
} from '../../../../../module/action/Articles';
import { downloadFile } from '../../../../../module/ConstantFunctions';
import DeletePostModal from '../../../../../Constants/deletePostModal';
import DownloadIcon from '../../../../../Assets/Icons/DownloadIcon';
import UploadIcon from '../../../../../Assets/Icons/UploadIcon';
import DeleteIcon from '../../../../../Assets/Icons/DeleteIcon';
import { assetURL } from '../../../../../api/utils';
import Spinner from '../../../../../Constants/Spinner';

const ArticleRow = ({ a, i, showDeleteModal, showModal }) => {
  let [downloadLoader, setDownloadLoader] = useState(false);
  return (
    <div className="md:table-row flex-wrap flex  w-full  py-2  " key={i}>
      <div className="md:table-cell font-semibold bg-[#f5f5f5] md:w-[50%] w-full pr-8 py-2	 rounded-l-xl text-right">
        <span className="urduText" dir="ltr">
          {a.titleName ? a.titleName : ''}
        </span>
      </div>
      <div className="md:table-cell font-semibold bg-[#f5f5f5] md:w-auto w-auto py-2 md:mr-0 mr-1	">
        {a.pdf_file ? (
          <div className="flex items-center">
            <button
              onClick={() => showModal(a, 'Change PDF')}
              className="text-[#2a9134] bg-white py-[15px]  w-[160px]  rounded-xl border-[#2a9134] border-[1px] mr-4 leading-[10px]">
              Change PDF
            </button>
            <button
              disabled={downloadLoader}
              className="bg-[#DEEAE1] h-[40px] w-[40px] rounded-full flex items-center justify-center ml-4"
              onClick={() => {
                downloadFile(
                  a.pdf_file_url ? a.pdf_file_url : `${assetURL}${a.pdf_file}`,
                  a.titleName.slice(0, 10),
                  'application/pdf',
                  setDownloadLoader
                );
              }}>
              {downloadLoader ? <Spinner color={'#2a9134'} /> : null}
              <span
                className={
                  downloadLoader ? `opacity-0 flex items-center justify-center` : 'flex items-center justify-center'
                }>
                <DownloadIcon />
              </span>
            </button>
          </div>
        ) : (
          <button
            onClick={() => showModal(a, 'Upload PDF')}
            className="ext-white bg-[#2a9134] py-[15px] text-white  rounded-xl w-[160px] leading-[10px]">
            Upload PDF
          </button>
        )}
      </div>
      <div className="md:table-cell font-semibold bg-[#f5f5f5]  w-[152px]  pr-2 py-2 rounded-r-xl">
        <div className="w-full justify-end flex">
          <button
            onClick={() => {
              showDeleteModal(a);
            }}
            className="w-[152px] h-[40px] flex text-white bg-[#ca3030] py-[15px]  rounded-xl text-sm  justify-center items-center leading-[10px]">
            <DeleteIcon svgProps={{ className: 'mr-[10.5px]' }} pathProp={{ fill: '#fff' }} />
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

const Articles = () => {
  const ArticlesData = useSelector(e => e.Articles.ArticlesData);
  const dispatch = useDispatch();

  const [editData, setEditData] = useState(false);
  const [editDataLoader, setEditDataLoader] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(true);

  const deleteArticle = id => {
    dispatch(DeleteArticleAction(id));
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalName, setModalName] = useState('');
  const showModal = (a, name) => {
    setIsModalOpen(true);

    setEditData(a);
    setModalName(name);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setEditData(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setEditData(false);
  };

  const searchArticle = e => {
    let text = e.target.value;
    dispatch(GetSearchArticleAction(text));
  };

  const [deletePost, setDeletePost] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const showDeleteModal = a => {
    setIsDeleteModalOpen(true);
    setDeletePost(a);
  };

  const handleDeleteOk = () => {
    setIsDeleteModalOpen(false);
    setDeletePost(false);
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
    setDeletePost(false);
  };

  const deleteNewsPostLoader = useSelector(e => e.NewsPosts.deleteNewsPostLoader);
  const deletePostFn = () => {
    dispatch(DeleteArticleAction(deletePost._id, handleDeleteOk));
  };

  return (
    <div>
      <SearchInput
        changeFunction={searchArticle}
        searchText={true}
        width={'w-full md:w-[560px]'}
        placeHolder={'Write for article'}
      />
      <div className="listArticles">
        <div className="md:table flex flex-col w-full my-6 border-spacing-y-[4px]">
          <div className="md:table-row w-full  py-6  ">
            <div className="md:table-cell font-semibold bg-[#f5f5f5] w-[50%] pl-8 py-6 rounded-l-xl">
              Article Title{' '}
            </div>
            <div className="md:table-cell font-semibold bg-[#f5f5f5] w-[calc(40%-152px)] py-6 hidden">PDF File</div>
            <div className="md:table-cell font-semibold bg-[#f5f5f5] w-[152px]  pr-2 py-2 rounded-r-xl hidden ">
              Execution
            </div>
          </div>
          {ArticlesData?.length
            ? ArticlesData.map((a, i) => (
                <ArticleRow a={a} i={i} showDeleteModal={showDeleteModal} showModal={showModal} />
              ))
            : null}
        </div>
      </div>
      <Modal footer={false} title={modalName} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        {editData ? (
          <div className=" w-full">
            <div className="my-8">
              <p className="text-sm text-black font-semibold">PDF File</p>
              <p className="text-sm text-[#7b867c]  mt-2">Select PDF file from your computer</p>
              <label className="relative text-[#2a9134] flex mt-2 items-center">
                <input
                  type="file"
                  accept=".pdf"
                  className="hidden w-0 absolute"
                  onChange={ev => {
                    if (ev.target.files && ev.target.files[0]) {
                      let data = { ...editData };
                      data.pdf_file = ev.target.files[0];
                      setEditData(data);
                      setUpdateDisable(false);
                    }
                  }}
                />
                <div className="flex w-[150px] items-center justify-center mr-4 rounded-xl text-[#2a9134] font-semibold py-3.5 px-8 border-[1px] border-[#2a9134] bg-white">
                  <UploadIcon className="mr-1.5" />
                  Upload
                </div>

                {/* {a.pdfName ? */}
                <p className="text-black text-sm font-semibold w-[40%] text-text-ellipsis">
                  {editData.pdf_file
                    ? typeof editData.pdf_file === 'string' || editData.pdf_file === null
                      ? editData.pdf_file
                      : editData.pdf_file.name
                    : ''}
                </p>
                {/* : null} */}
              </label>
            </div>
          </div>
        ) : null}
        <button
          disabled={editDataLoader || updateDisable}
          className="relative mt-6 px-[90px] rounded-xl bg-[#2a9134] text-white py-3.5 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={() => {
            setEditDataLoader(true);
            dispatch(UpdateArticleAction(editData, handleOk, setEditDataLoader));
          }}>
          {editDataLoader ? <Spinner /> : 'Update'}
        </button>
      </Modal>

      {/* <ConfirmaModal //
        open={deleteModalOpen}
        onCancel={handleDeleteCancel}
        title="Do you want to delete this book?"
        content="All post related to this book will be removed"
        cancelText="No"
        okText="Yes, Delete"
        onOk={deleteBook}
      /> */}

      <DeletePostModal
        isDeleteModalOpen={isDeleteModalOpen}
        setIsDeleteModalOpen={setIsDeleteModalOpen}
        showDeleteModal={showDeleteModal}
        handleDeleteOk={handleDeleteOk}
        handleDeleteCancel={handleDeleteCancel}
        deletePost={deletePost}
        setDeletePost={setDeletePost}
        loader={deleteNewsPostLoader}
        deleteFun={deletePostFn}
        modalText="Do you want to delete this Article?"
      />
    </div>
  );
};
export default Articles;
